module.exports = __webpack_public_path__ + "img/no-data.71e17a27.svg";